/**
 * Device Operations Actions Cell - Frontend
 * @description Cell component for displaying operation actions
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellContext } from '@tanstack/react-table';
import { DashboardOperation } from '@/types/dashboard.types';
import { TableButton } from '@/components/ui/TableButton';
import { MapPin, Activity } from 'lucide-react';
import { PERMISSIONS } from '@/contexts/PermissionsContext';

interface DeviceOperationsActionsCellProps {
  info: CellContext<DashboardOperation, unknown>;
  actions: {
    onCenterMap: (operationId: string) => void;
    onViewLectures: (deviceId: string, operationId: string) => void;
  };
  deviceId?: string;
}

export const DeviceOperationsActionsCell: React.FC<DeviceOperationsActionsCellProps> = ({
  info,
  actions,
  deviceId,
}) => {
  const { t } = useTranslation();
  const operation = info.row.original;

  return (
    <div className="flex space-x-1">
      <TableButton
        permission={PERMISSIONS.OPERATIONAL_READ}
        onClick={(e) => {
          e.stopPropagation();
          actions.onCenterMap(operation.id);
        }}
        icon={<MapPin className="h-4 w-4" />}
        label={t('pages.operations.centerMap')}
        variant="primary"
      />

      <TableButton
        permission={PERMISSIONS.OPERATIONAL_READ}
        onClick={(e) => {
          e.stopPropagation();
          if (deviceId) {
            actions.onViewLectures(deviceId, operation.id);
          }
        }}
        icon={<Activity className="h-4 w-4" />}
        label={t('pages.operations.viewLectures')}
        variant="secondary"
        disabled={!deviceId}
      />
    </div>
  );
};
